import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { DataTableColumnFiltersApi, DataTableColumnModel, DataTableStateModel } from './dynamic-table.model';
import { TranslateService } from '@ngx-translate/core';

const routes = {
  getTranslatedText: () => `/v1/language/translate`
};

@Injectable({
  providedIn: 'root'
})
export class DynamicTableService {

  constructor(private http: HttpClient, private translate: TranslateService) { }


  prepareExportDataPayload(tableState: DataTableStateModel) {
    // columns
    let columns: DataTableColumnModel[] = tableState.datatableColumns?.filter(c => c.showColumn).map(c => {
      return {
        name: this.translate.instant(c.name),
        prop: c.prop
      }
    }) ?? [];
    // filters
    let filters: DataTableColumnFiltersApi[] = tableState.datatableFilters?.map(f => {
      return {
        columnName: f.columnName,
        columnSelectedValues: f.columnSelectedValues,
        columnSearchValue: f.columnSearchValue,
        columnDateTimeRangeValues: f.columnDateTimeRangeValues
      }
    }) ?? [];
    // payload
    return {
      sortingValue: tableState.sortingValue,
      datatableColumns: columns ?? [],
      datatableFilters: filters ?? []
    };
  }

  getExportDataFile(apiPath: string, tableState: DataTableStateModel, querySearch?: string): Observable<any> {
    // params
    let params = new HttpParams().set('gridName', tableState.gridName);
    if (tableState.tableType) {
      params = params.set('dashboardType', tableState.tableType);
    }
    if (querySearch) {
      params = params.set('querySearch', querySearch);
    }
    // payload
    const payload = this.prepareExportDataPayload(tableState);
    return this.http.post(apiPath, payload, {
      params,
      responseType: 'blob'
    });
  }

  generateExportFileName(dataTableState: DataTableStateModel): string {
    return `${dataTableState.gridName}${dataTableState.tableType ? '_' : ''}${dataTableState.tableType ?? ''}_${new Date().toISOString().split('.')[0].replaceAll('T', '_').replaceAll('-', '_')}`
  }

}
